
export { ShoppingBagButton } from "/codebuild/output/src3584820406/src/packages/shared-components/src/components/ShoppingBagButton/index.ts"